import api from "../service/api";

async function list_all() {
  try {
    const { data } = await api.get(`/api/workflow-functions`);
    return data;
  } catch {
    return [];
  }
}

async function save(body) {
  try {
    const { data } = await api.post(`/api/workflow-functions`, body);
    return data;
  } catch {
    return false;
  }
}
async function getDynamicResultParams(id, params) {
  try {
    const { data } = await api.post(
      `/api/workflow-functions/dynamic-result/${id}`,
      params
    );
    return data;
  } catch {
    return [];
  }
}

async function getDynamicParams(id, params, parametroBuscado) {
  try {
    const { data } = await api.post(
      `/api/workflow-functions/dynamic-param/${id}/${parametroBuscado}`,
      params
    );
    return data;
  } catch {
    return [];
  }
}

export default {
  list_all,
  save,
  getDynamicResultParams,
  getDynamicParams,
};
